Vue.component("MpModuleRequestDossier", {

    props: {
        title: {
            type: String,
            required: true
        },
        image: {
            type: String,
            required: false,
            default: ''
        },
        placeHolderEmail: {
            type: String,
            required: true
        },
        btnLabel: {
            type: String,
            required: true
        },
        fsecureLabel: {
            type: String,
            required: true
        },
        serviceName: {
            type: String,
            required: false,
            default: ''
        },
        serviceSection: {
            type: String,
            required: false,
            default: ''
        }
    },

    data: function() {
        return {
            RESPONSE_OK: 'OK',
            RESPONSE_KO: 'KO',
            VALIDATION_OK: 1,
            VALIDATION_KO: 0,
            FORM_URL: '/services/request-dossier',

            email: '',
            privacity: false,
            fsecure: '',

            errors: [],
            successMessage: '',
            validated: false,

            isSending: false,
            isLegalShown: false,
            isInitialized: false,
        };
    },

    computed: {
        classModifier: function() {
            var className = 'dossier-cta__cover--contracts';

            switch (this.serviceSection) {
                case 'customproducts':
                case 'platts':
                case 'argus':
                    className = 'dossier-cta__cover--contracts';
                break;

                case 'gasoleomp':
                case 'publictender':
                case 'ac':
                    className = 'dossier-cta__cover--markets';
                break;

                case 'equipment':
                    className = 'dossier-cta__cover--equipment';
                break;
            }

            return className;
        },

        coverImage: function() {
            return 'background-image: url("'+this.image+'")';
        },

        emailCheck: function() {
            return !this.validated || FormValidator.isValidEmail(this.email);
        },

        privacityCheck: function() {
            return (!this.validated || this.privacity);
        },

        dataForm: function() {
            return Serializer.serialize({
                'email': this.email,
                'service': this.serviceName,
                'privacity': this.privacity,
                'fsecure': this.fsecure
            });
        },
    },

    methods: {
        closeLegalModal: function() {
            noScroll.off();
            this.isLegalShown = false;
        },

        showLegalConditions: function(ev) {
            if (ev.target.tagName === 'A') {
                ev.preventDefault();
                noScroll.on();
                this.isLegalShown = true;
            }
        },

        cleanErrors: function() {
            this.errors = [];
        },

        addError: function(errorMsg) {
            if (this.errors.length > 0) {
                return;
            }

            this.errors.push(errorMsg);
        },

        validateForm: function() {
            /// error_data, data_ko & error_privacity
            /// are globally injected from PHP controller
            var isValid = true;

            this.cleanErrors();
            this.successMessage = '';
            this.validated = true;

            if (!this.emailCheck) {
                isValid = false;
                this.addError(data_ko);
            }

            if (!this.privacityCheck) {
                isValid = false;
                this.addError(error_privacity);
            }

            return isValid;
        },

        resetForm: function() {
            this.email = '';
            this.privacity = false;

            this.validated = false;
            this.cleanErrors();
        },

        onRequestSend: function(response) {
            this.isSending = false;

            if (response.data.result === this.RESPONSE_OK) {
                this.successMessage = response.data.message;
                this.resetForm();
            } else {
                this.addError(response.data.message);
            }
        },

        requestDosier: function(ev) {

            if (!this.isSending && this.validateForm()) {
                this.isSending = true;

                axios
                    .post(this.FORM_URL, this.dataForm)
                    .then(this.onRequestSend)
                    .catch(function(error) {
                        console.log(error);
                    });
            }
        },

        toggleLegalConditions: function(ev) {
            this.isLegalShown = !this.isLegalShown;
        },

        init: function() {
            if (this.isInitialized) {
                return;
            }

            this.isInitialized = true;
            this.$refs.fsecure.style.display = 'none';
        },
    },

    mounted: function() {
        this.init();
    },

    template: '\
    <div class="dossier-cta" ref="dossierRequest">\
        <div class="dossier-cta__wrapper">\
\
            <div class="dossier-cta__cover" :class="classModifier" :style="coverImage"></div>\
\
            <div class="dossier-cta__content">\
                <p v-html="title"></p>\
\
                <div class="dossier-cta__form u-mt-l">\
                    <div class="row">\
                        <div class="col-12 col-md-7">\
                            <div class="form__group u-mt-0" :class="{\'form__group--ko\' : !emailCheck}">\
                                <div class="form__control-wrapper">\
                                    <input class="form__control form-control" :class="{\'form__group--ko\' : !emailCheck}" type="text" :placeholder="placeHolderEmail" v-model="email">\
                                </div>\
                            </div>\
\
                            <div ref="fsecure">\
                                <label for="fsecure">{{ fsecureLabel }}</label>\
                                <div>\
                                    <input type="text" name="fsecure" id="fsecure" ref="fsecure" v-model="fsecure">\
                                </div>\
                            </div>\
                        </div>\
\
                        <div class="col-12 col-md-5">\
                            <button class="btn btn--center btn--tertiary btn--block" @click.prevent="requestDosier()">{{ btnLabel }}</button>\
                        </div>\
                    </div>\
\
                    <div class="row">\
                        <div class="col-12">\
                            <div class="form__group">\
                                <label class="checkbox" :class="{\'checkbox--ko\' : !privacityCheck}">\
                                    <input type="checkbox" v-model="privacity" id="privacity">\
                                    <span class="checkbox__indicator"></span>\
                                    <span @click="showLegalConditions" class="checkbox__label">\
                                        <slot name="legallabel"></slot>\
                                    </span>\
                                </label>\
                            </div>\
                        </div>\
                    </div>\
\
                    <div class="row">\
                        <div class="col-12">\
                            <div class="form__validation form__validation--ko" v-if="errors.length">\
                                <p class="form__validation-text" v-for="error in errors">\
                                    {{error}}\
                                </p>\
                            </div>\
\
                            <div class="form__validation form__validation--ok" v-if="successMessage">\
                                <p class="form__validation-text">\
                                    {{successMessage}}\
                                </p>\
                            </div>\
                        </div>\
                    </div>\
                </div>\
            </div>\
\
\
        </div>\
\
        <mp-modal\
            v-if="isLegalShown"\
            @close="closeLegalModal"\
            max-width="60%"\
            max-height="420px"\
        >\
            <h1 class="modal__title" slot="header">\
                <slot name="legaltitle"></slot>\
            </h1>\
            <div class="html-content-modal" slot="content">\
                <slot name="legalcontent"></slot>\
            </div>\
        </mp-modal>\
    </div>\
    ',
});
